import Image from "next/image";
import { Stack, GridItem, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { EXTEND_CONSTANTS } from "./constants";

const ExtendComponent = () => {
  const TextVariant = useTextVariants();
  const { title, image, desc } = EXTEND_CONSTANTS;
  return (
    <Stack
      pr={{ md: 16 }}
      spacing={8}
      border="1px solid #9ECFFF"
      pt={8}
      bgColor={"#F9FAFC"}
    >
      <SimpleGrid
        gridTemplateColumns={{ base: "1fr", sm: "0.75fr 1fr" }}
        spacing={8}
        pt={8}
      >
        <GridItem>
          <Image
            src={image}
            alt="Kubernetes"
            width={500}
            height={350}
            style={{ transform: "rotate(-30deg)" }}
          />
        </GridItem>
        <GridItem width={{ base: "100%", sm: "90%" }} alignSelf={"center"} p={2}>
          <Stack spacing={8}>
            <Heading as="h2" fontWeight={"400"} fontSize={"40px"}>
              {title}
            </Heading>
            <Text variant={TextVariant} color="text.100">
              {desc}
            </Text>
          </Stack>
        </GridItem>
      </SimpleGrid>
    </Stack>
  );
};

export default ExtendComponent;
